import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Date_V2 extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            dateofallocation: '',
            dateofarivalatloadpoint: '',
            dateofloading: '',
            dateofdeparture: '',
            dateofarivalatoffloadpoint: '',
            dateofoffloading: '',
            plate_no: '',
        }
    }

    async componentDidMount() {
        let baseurl = myconfig.get_date_v2;
        let redirecttologin = myconfig.redirecttologin;
        let id = new URLSearchParams(this.props.location.search).get("id");
        this.setState({
            dateofallocation: '',
            dateofarivalatloadpoint: '',
            dateofloading: '',
            dateofdeparture: '',
            dateofarivalatoffloadpoint: '',
            dateofoffloading: '',
            plate_no: '',
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            id: id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    dateofallocation: res.data.data.dateofallocation,
                    dateofarivalatloadpoint: res.data.data.dateofarivalatloadpoint,
                    dateofloading: res.data.data.dateofloading,
                    dateofdeparture: res.data.data.dateofdeparture,
                    dateofarivalatoffloadpoint: res.data.data.dateofarivalatoffloadpoint,
                    dateofoffloading: res.data.data.dateofoffloading,
                    plate_no: res.data.data.plate_no,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }


    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    btnsave = (event) => {
        event.preventDefault();
        let baseurl = myconfig.update_date_v2;
        let redirecttologin = myconfig.redirecttologin;
        let id = new URLSearchParams(this.props.location.search).get("id");
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            id: id,
            dateofallocation:this.state.dateofallocation,
            dateofarivalatloadpoint:this.state.dateofarivalatloadpoint,
            dateofloading:this.state.dateofloading,
            dateofdeparture:this.state.dateofdeparture,
            dateofarivalatoffloadpoint:this.state.dateofarivalatoffloadpoint,
            dateofoffloading:this.state.dateofoffloading,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.datas.map(value => {
                let manage = null;
                let report = null;
                if (this.state.allovehs.usermatrix.update)
                    manage =
                        <td><a href="#"
                               onClick={(event => this.showcu(event, value.id))}>Manage</a></td>
                if (this.state.allovehs.usermatrix.update)
                    report =
                        <td><a href={myconfig.redirectomovement_by_allocationveh + "?id=" + value.id}
                               target="_blank">Report</a></td>

                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    {manage}
                    {report}
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.status}</td>
                    <td>{value.orderdate}</td>
                    <td>{value.volume}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.customer_id}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Date Management V2</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Date Management</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Date Management</h3>
                                    </div>
                                    <form>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>Plate No</label>
                                                <input disabled={true} type="email" className="form-control"
                                                      name="plate_no" value={this.state.plate_no} onChange={this.inputmgt}/>
                                            </div>
                                            <div className="form-group">
                                                <label>Allocation</label>
                                                <input type="email" className="form-control"
                                                       name="dateofallocation" value={this.state.dateofallocation} onChange={this.inputmgt}/>
                                            </div>
                                            <div className="form-group">
                                                <label>Arrival @ Loading </label>
                                                <input type="email" className="form-control"
                                                       name="dateofarivalatloadpoint" value={this.state.dateofarivalatloadpoint} onChange={this.inputmgt}/>
                                            </div>
                                            <div className="form-group">
                                                <label>Load</label>
                                                <input type="email" className="form-control"
                                                       name="dateofloading" value={this.state.dateofloading} onChange={this.inputmgt}/>
                                            </div>
                                            <div className="form-group">
                                                <label>Departure</label>
                                                <input type="email" className="form-control"
                                                       name="dateofdeparture" value={this.state.dateofdeparture} onChange={this.inputmgt}/>
                                            </div>

                                            <div className="form-group">
                                                <label>Arrival @ Offload</label>
                                                <input type="email" className="form-control"
                                                       name="dateofarivalatoffloadpoint" value={this.state.dateofarivalatoffloadpoint} onChange={this.inputmgt}/>
                                            </div>
                                            <div className="form-group">
                                                <label>Offload</label>
                                                <input type="email" className="form-control"
                                                       name="dateofoffloading" value={this.state.dateofoffloading} onChange={this.inputmgt}/>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="submit" className="btn btn-primary" onClick={this.btnsave}>Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Date_V2;
